import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { devConfig, profile } from '../../../config/config'; // Importing configuration settings

/**
 * Class representing the view for adding an admin user.
 * @extends JetView
 */
export default class addAdminUserView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        var arrayAdd = []; // Array to hold added partners
        var arrayWithoutAdd = []; // Array to hold partners not added
        const lenguages = [
            // Supported languages for user selection
            { id: 'ES', value: 'español (o castellano) (ES)' },
            { id: 'EN', value: 'English (EN)' },
            { id: 'PT', value: 'Portugués (PT)' },
        ];
        const main = {
            // Main form configuration
            margin: 5,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'text', // Text input for login access
                            name: 'LoginAccess',
                            label: _('Login para acceso'),
                            labelPosition: 'top',
                            placeholder: _('Login para acceso'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text', // Text input for password
                            name: 'Password',
                            label: _('Clave'),
                            labelPosition: 'top',
                            placeholder: _('Clave'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for user type selection
                            name: 'TypeUser',
                            id: 'TypeUser',
                            localId: 'TypeUser:combo',
                            label: _('Tipo de usuario'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for user state selection
                            name: 'State',
                            localId: 'State:combo',
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'A', value: _('Activo') },
                                { id: 'I', value: _('Inactivo') },
                                { id: 'R', value: _('Retirado') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for user country selection
                            name: 'UserCountry',
                            localId: 'UserCountry:combo',
                            label: _('Usuario de País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'combo', // Combo box for agent selection
                            name: 'AgentId',
                            minWidth: 200,
                            label: "<span class='icon-shop'></span>" + _('Concesionario'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data feed function for agent selection
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Agent/GetAllAgents',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.data);
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                    ],
                },
            ],
        };
        const main2 = {
            // Secondary form configuration
            margin: 5,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'text', // Text input for first name
                            name: 'FirstName',
                            label: "<span class='icon-user'></span>" + _('Nombre del usuario'),
                            labelPosition: 'top',
                            placeholder: _('Nombre del usuario'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for preferred language selection
                            name: 'PreferredLanguage',
                            localId: 'PreferredLanguage:combo',
                            label: _('Idioma preferido:'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: lenguages,
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };
        const main3 = {
            // Tertiary form configuration
            margin: 5,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountryId',
                            id: 'country',
                            localId: 'Country:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for currency selection
                            name: 'CurrencyId',
                            id: 'currency',
                            localId: 'Currency:combo',
                            label: "<span class='webix_icon mdi mdi-coin'></span>" + _('Moneda'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };
        const main4 = {
            // Configuration for partner selection
            margin: 5,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'forminput', // Double list for partner selection
                            body: {
                                view: 'dbllist',
                                id: 'dbllistAdd',
                                list: { height: 200, scroll: true },
                                labelLeft: _('Partners'),
                                labelRight: _('Partners Seleccionados'),
                                data: profile.Partners,
                            },
                            labelWidth: 140,
                            labelAlign: 'right',
                        },
                    ],
                },
            ],
        };
        const options_main = {
            // Options for special status and pinagent
            margin: 5,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'richselect', // Dropdown for special status
                            name: 'SpecialStatus',
                            localId: 'SpecialStatus:combo',
                            label: _('Estado especial'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'A', value: _('Activo') },
                                { id: 'I', value: _('Inactivo') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for pinagent selection
                            name: 'Pinagent',
                            localId: 'Pinagent:combo',
                            label: _('Pinagent'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };
        const options_main2 = {
            // Options for locked sales and print receipt box
            margin: 5,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'richselect', // Dropdown for locked sales
                            name: 'Lockedsales',
                            localId: 'Lockedsales:combo',
                            label: _('Bloqueado para ventas'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for print receipt box
                            name: 'PrintReceiptBox',
                            localId: 'PrintReceiptBox:combo',
                            label: _('Imprime recibo caja'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };
        const options_main3 = {
            // Options for allows recharges and activate registration
            margin: 5,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'richselect', // Dropdown for allows recharges
                            name: 'AllowsRecharges',
                            localId: 'AllowsRecharges:combo',
                            label: _('Permite recargas'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for activate registration
                            name: 'ActivateRegistration',
                            localId: 'ActivateRegistration:combo',
                            label: _('Permite activar reg'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };
        const betshop_details = {
            // Configuration for betshop details
            margin: 5,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'text', // Text input for contact name
                            name: 'ContactName',
                            label: _('Nombre del contacto'),
                            labelPosition: 'top',
                            placeholder: _('Nombre del contacto'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text', // Text input for email
                            name: 'Email',
                            label: _('Correo electrónico'),
                            labelPosition: 'top',
                            placeholder: _('Correo electrónico'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text', // Text input for description
                            name: 'Description',
                            label: "<span class='icon-file-text1'></span>" + _('Descripción'),
                            labelPosition: 'top',
                            placeholder: _('Descripción'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text', // Text input for mobile phone
                            name: 'MobilePhone',
                            label: _('Teléfono'),
                            labelPosition: 'top',
                            placeholder: _('Teléfono'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for concessionaire selection
                            name: 'Concessionaire',
                            id: 'Concessionaire',
                            localId: 'Concessionaire:combo',
                            label: _('Concesionario'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for subconcessionaire selection
                            name: 'Subconcessionaire',
                            id: 'Subconcessionaire',
                            localId: 'Subconcessionaire:combo',
                            label: _('Subconcesionario'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for province/region selection
                            name: 'ProvinceRegion ',
                            id: 'ProvinceRegion',
                            localId: 'ProvinceRegion:combo',
                            label: _('Provincia/Región'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown for city selection
                            name: 'City',
                            id: 'City',
                            localId: 'City:combo',
                            label: "<span class='icon-language'></span>" + _('Ciudad'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text', // Text input for address
                            name: 'Address',
                            label: _('Dirección'),
                            labelPosition: 'top',
                            placeholder: _('Dirección'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text', // Text input for district
                            name: 'District',
                            label: _('Barrio'),
                            labelPosition: 'top',
                            placeholder: _('Barrio'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text', // Text input for phone
                            name: 'Phone',
                            label: _('Teléfono'),
                            labelPosition: 'top',
                            placeholder: _('Teléfono'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };
        const center_right = {
            // Configuration for daily quota and commission
            margin: 5,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'text', // Text input for daily quota reloads
                            name: 'DailyQuotaReloads',
                            label: _('Limite diario de recargas'),
                            labelPosition: 'top',
                            placeholder: _('Limite diario de recargas'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text', // Text input for commission reloads
                            name: 'CommissionReloads',
                            label: _('Comisión recargas'),
                            labelPosition: 'top',
                            placeholder: _('Comisión recargas'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
                {
                    rows: [
                        {
                            view: 'text', // Text input for minimum bet
                            name: 'MinimumBet',
                            label: _('Apuesta mínima'),
                            labelPosition: 'top',
                            placeholder: _('Apuesta mínima'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text', // Text input for daily limit
                            name: 'DailyLimit',
                            label: _('Límite diario'),
                            labelPosition: 'top',
                            placeholder: _('Límite diario'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };
        const right = {
            // Placeholder for right section
            margin: 5,
            rows: [],
        };
        const upper_section = {
            // Accordion for main data and configuration
            multi: true,
            view: 'accordion',
            css: 'betShop',
            margin: 10,
            rows: [
                {
                    header: _('Datos Principales'), // Header for main data section
                    body: {
                        id: 'a',
                        padding: 10,
                        rows: [
                            {
                                margin: 10,
                                cols: [
                                    main,
                                    {
                                        rows: [
                                            {
                                                margin: 10,
                                                cols: [main2, main3],
                                            },
                                            main4,
                                        ],
                                    },
                                    {},
                                ],
                            },
                        ],
                    },
                    collapsed: false,
                },
                {
                    header: _('Datos Configuración'), // Header for configuration data section
                    id: 'conf',
                    body: {
                        id: 'b',
                        padding: 10,
                        rows: [
                            {
                                responsive: 'b',
                                margin: 10,
                                cols: [options_main, options_main2, options_main3],
                            },
                        ],
                    },
                    collapsed: true,
                },
            ],
        };
        const buttons = {
            // Configuration for action buttons
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear the form fields
                    },
                },
                {
                    view: 'button', // Button to save the form data
                    value: _('Guardar'),
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        if (this.getRoot().validate()) {
                            // Validate form fields
                            if (arrayAdd.length > 0) {
                                const newdata = this.getRoot().getValues(); // Get form values
                                newdata.Partners = arrayAdd; // Add selected partners
                                arrayWithoutAdd = []; // Reset array for partners not added
                                for (var i = 0; i < profile.Partners.length; i++) {
                                    var flag = false;
                                    for (var j = 0; (j < arrayAdd.length) & !flag; j++) {
                                        if (profile.Partners[i].id == arrayAdd[j]) flag = true; // Check if partner is added
                                    }
                                    if (!flag)
                                        arrayWithoutAdd.push(
                                            profile.Partners[i].id, // Add to not added partners
                                        );
                                }
                                newdata.PartnersWithoutAdd = arrayWithoutAdd; // Add not added partners to data
                                this.app.callEvent('adminUser:save', [newdata]); // Trigger save event
                            } else {
                                webix.message({
                                    type: 'error',
                                    text: _(
                                        'Seleccione por lo menos un Partner', // Error message if no partner is selected
                                    ),
                                });
                            }
                        } else {
                            webix.message({
                                type: 'error',
                                text: _('Completa los campos...'), // Error message for incomplete fields
                            });
                            $$('conf').expand(); // Expand configuration section
                        }
                    },
                },
            ],
        };
        this.on(this.app, 'onChangePartnets', (array) => {
            // Event listener for partner changes
            if (array[0] != '') {
                arrayAdd = array; // Update added partners
            } else {
                arrayAdd = []; // Reset added partners if none selected
            }
        });
        webix.ui.fullScreen(); // Set UI to full screen mode
        return {
            view: 'form', // Main form configuration
            id: 'formId',
            scroll: 'y',
            rows: [upper_section, buttons], // Add sections to the form
            elementsConfig: {
                on: {
                    onChange: function (newv, oldv) {
                        // Event listener for field changes
                        if (newv != undefined) {
                            this.validate(); // Validate field on change
                        }
                    },
                },
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        var vthis = this; // Reference to the current instance
        const _ = this.app.getService('locale')._; // Localization service
        $$('dbllistAdd').attachEvent('onChange', function (id, e, node) {
            // Event listener for double list changes
            vthis.app.callEvent('onChangePartnets', [
                $$('dbllistAdd').getValue().split(','), // Update partners based on selection
            ]);
        });
        this.on(this.app, 'adminUser:save', (data) => {
            // Event listener for saving admin user
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .post(devConfig.geturlApi() + 'AdminUser/SaveAdminUser', data, {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error'); // Error message on save failure
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var json = JSON.parse(text); // Parse response
                        webix.message(_('Guardado')); // Success message
                        vthis.show(
                            'adminUserManagement?user=' + json.id + '/security.adminuser.informationAdminUser', // Redirect to user management
                        );
                    },
                });
        });
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on countries fetch failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text.replace(/"Id"/g, '"id"').replace(/"Name"/g, '"value"'));
                    var optionsProvinceRegions = $$('country').getList(); // Get country dropdown list
                    optionsProvinceRegions.clearAll(); // Clear existing options
                    optionsProvinceRegions.parse(data.Data); // Parse and add new options
                },
            });
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'AdminUser/GetTypeUser', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on type user fetch failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text); // Parse response
                    var optionsTypeUser = $$('TypeUser').getList(); // Get type user dropdown list
                    optionsTypeUser.clearAll(); // Clear existing options
                    optionsTypeUser.parse(data.Data); // Parse and add new options
                },
            });
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentsTwoLevels?isList=1', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on agents fetch failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text.replace(/"UserName"/g, '"id"').replace(/"Name"/g, '"value"'));
                    console.log(data.Data.Children); // Log fetched agents data
                },
            });
        this.app.callEvent('form:update', [this.getParam('user', true)]); // Update form with user data
        this.on(
            this.app,
            'customer:updatedata',
            (person) => form.setValues(person), // Set form values based on updated customer data
        );
        this.on(this.app, 'person:select', (person) => form.setValues(person)); // Set form values based on selected person
        $$('country').attachEvent('onChange', function (newv, oldv) {
            // Event listener for country selection change
            var optionscountries = this.getList().getItem(newv); // Get selected country options
            var optionscurrencies = $$('currency').getList(); // Get currency dropdown list
            optionscurrencies.clearAll(); // Clear existing options
            optionscurrencies.parse(optionscountries.currencies); // Parse and add new currency options
            webix.message('Value changed from: ' + oldv + ' to: ' + newv); // Log value change
        });
    }

    /**
     * Retrieves and localizes combo options for positions, tags, and cities.
     */
    getLocalizedComboOptions() {
        const _ = this.app.getService('locale')._; // Localization service
        let p_options = webix.copy(getPositions()); // Get positions options
        p_options.map((x) => (x.value = _(x.value))); // Localize position values
        this.$$('position:combo').getPopup().getList().parse(p_options); // Parse and set position options
        let t_options = webix.copy(getTags()); // Get tags options
        t_options.map((x) => (x.value = _(x.value))); // Localize tag values
        this.$$('tags:combo').getPopup().getList().parse(t_options); // Parse and set tag options
        let c_options = webix.copy(getCities()); // Get cities options
        c_options.map((x) => (x.value = _(x.value))); // Localize city values
        this.$$('cities:combo').getPopup().getList().parse(c_options); // Parse and set city options
    }
}

// FILE DOCUMENTED
